import { getCurrentUser, signOut } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { useEffect, useState } from "react";
import {
	clearLastActivity,
	isInactivityExpired,
} from "../../helper/auth-helper";

export interface UseIsSignedInToAmplifyResult {
	isLoading: boolean;
	isSignedIn: boolean;
}

export function useIsSignedInToAmplify(): UseIsSignedInToAmplifyResult {
	const [isLoading, setLoading] = useState(true);
	const [isSignedIn, setIsSignedIn] = useState(false);

	//Get the current authentication state
	useEffect(() => {
		setLoading(true);

		getCurrentUser()
			.then(() => {
				//Sign out if the user has been inactive for too long
				if (isInactivityExpired()) {
					return signOut().then(() => {
						setIsSignedIn(false);
					});
				}
				setIsSignedIn(true);
			})
			.catch(() => {
				setIsSignedIn(false);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [setIsSignedIn]);

	//Subscribe to authentication state changes
	useEffect(() => {
		const unsubscribe = Hub.listen("auth", ({ payload }) => {
			switch (payload.event) {
				case "signedIn":
					//Invalidate the last activity timestamp when we sign in
					clearLastActivity();

					setIsSignedIn(true);
					break;
				case "signedOut":
					setIsSignedIn(false);
					break;
			}
		});

		return () => {
			unsubscribe();
		};
	}, [setIsSignedIn]);

	return {
		isLoading,
		isSignedIn,
	};
}
